/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-hook-form';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { currencyCodes } from '../../../../misc/currencyCodes';
import { convertCurrency } from '../../../../misc/ecbCurrencyRates';
import Dropdown from '../Dropdown'; // import wrapper for the common Dropdown component
import InputField from '../../../../elements/InputField';

dayjs.extend(utc);

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function Step1AccountName({ index, updateWorkflowStatus, form, signalNext, setSignalNext }) {
  const { t: tL } = useTranslation('app', { keyPrefix: 'schema.pension.account' });
  const { t } = useTranslation(['addAccount'], { keyPrefix: 'pension' });

  const { register, control, getValues, setValue, trigger, watch } = form;

  // this allows only to import a slice of the entire form state
  const formState = useFormState({ control, name: ['name', 'currency', 'productPurchaseDate'] });
  const { errors, isValid } = formState;

  //--------------------------------------------------------------------------------
  // prepare empty form
  //--------------------------------------------------------------------------------

  useEffect(() => {
    const existingCurrency = getValues('currency');
    if (!existingCurrency) {
      setValue('currency', currencyCodes[0], { shouldDirty: false });
    }
  }, []);

  //--------------------------------------------------------------------------------
  // update displayErrors and synchronise validation state with parent workflow
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (isValid) {
      updateWorkflowStatus(index, true);
    } else {
      updateWorkflowStatus(index, false);
    }
  }, [isValid]);

  //--------------------------------------------------------------------------------
  // subscribe to signal from parent that the user has clicked the "next" button
  // (and then trigger all validations to show errors)
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (signalNext) {
      trigger();
      setSignalNext(false);
    }
  }, [signalNext]);

  //---------------------------------------------------------------------------------------------
  // if accountCurrency !== baseCurrency, display current fx rate for the user's convenience
  //---------------------------------------------------------------------------------------------

  // when user selects a non-base-currency for the transaction, get the fx rate in the background and put it into the form
  // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
  const baseCurrency = useSelector((state) => state.user.profile.settings.baseCurrency);

  const accountCurrency = watch('currency');
  const isBaseCurrencySameAsAccountCurrency = accountCurrency === baseCurrency;

  // update isBaseCurrencySameAsAccountCurrency in form state
  useEffect(() => {
    setValue('isBaseCurrencySameAsAccountCurrency', isBaseCurrencySameAsAccountCurrency);
  }, [isBaseCurrencySameAsAccountCurrency]);

  useEffect(() => {
    async function updateFxRate() {
      if (!isBaseCurrencySameAsAccountCurrency && accountCurrency && baseCurrency) {
        try {
          const newRate = await convertCurrency(1, accountCurrency, baseCurrency, dayjs.utc().startOf('day').valueOf());
          setValue('fxRate', newRate, { shouldDirty: true }); // sets the form to dirty to trigger the useEffect depending on formState
        } catch (e) {
          console.error('Error: Step1AccountName: convertCurrency error', e);
          setValue('fxRate', null);
        }
      } else {
        setValue('fxRate', null); // clear when base == account
      }
    }
    updateFxRate();
  }, [accountCurrency, baseCurrency, isBaseCurrencySameAsAccountCurrency]);

  //---------------------------------------------------------------------------------------------
  // render the form
  //---------------------------------------------------------------------------------------------

  return (
    <form className="space-y-6 md:space-y-0 md:grid md:gap-6">
      <div className="">
        <h3 className="text-xl md:text-2xl font-bold leading-6 text-gray-900">{t('wizardSteps.newAccount.title')}</h3>
        <p className="mt-1 text-sm text-gray-500">{t('wizardSteps.newAccount.subtitle')}</p>
      </div>

      <div className="py-3 lg:pb-4 grid gap-4 xs:gap-6 lg:gap-8 max-w-sm">
        <InputField
          id="name"
          category="pension"
          type="text"
          placeholder={tL('name.placeholder')}
          autoComplete="off"
          optional={false}
          register={register}
          errors={errors}
          validationRules={{ required: { value: true, message: tL('name.error') } }}
        />
        <Dropdown
          id="currency"
          list={currencyCodes}
          label={tL('currency.label')}
          placeholder={tL('currency.placeholder')}
          toolTip={tL('currency.tooltip')}
          register={register}
          optional={false}
          errors={errors}
          control={control}
          validationRules={{ required: { value: true, message: tL('currency.error') } }}
        />
        <InputField
          id="productPurchaseDate"
          category="pension"
          type="date"
          optional={false}
          autoComplete="off"
          register={register}
          errors={errors}
          validationRules={{
            required: { value: true, message: tL('productPurchaseDate.error') },
            validate: {
              isValidDate: (value) => {
                if (!dayjs(value, 'YYYY-MM-DD', true).isValid()) {
                  return tL('productPurchaseDate.errorInvalid');
                }
                return true;
              },
              notInFuture: (value) => {
                if (dayjs(value).isAfter(dayjs.utc(), 'day')) {
                  return tL('productPurchaseDate.errorFuture');
                }
                return true;
              },
            },
          }}
          transformValue={{
            setValueAs: (value) => (value ? dayjs.utc(value).valueOf() : value),
          }}
        />
      </div>
    </form>
  );
}

Step1AccountName.propTypes = {
  index: PropTypes.number.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  signalNext: PropTypes.bool,
  setSignalNext: PropTypes.func,
};
Step1AccountName.defaultProps = {
  signalNext: undefined,
  setSignalNext: () => {},
};

export default Step1AccountName;
